import { Injectable } from '@angular/core';
import {Transaction, TransactionList} from './transaction';
import {BaseService} from '../base/base.service';
import {TransactionSerializer} from 'src/app/transactions/transaction.serializer';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TransactionService extends BaseService<Transaction, TransactionList> {

  constructor(http: HttpClient) {
    super(http);
    this.endpoint = 'transactions' ;
    this.serializer = new TransactionSerializer();
  }
}
